@if (items?.length) {
  @if (scripts) {
    <div [innerHTML]="scripts | replaceTokensArray: {keys: item}  | safe : 'html'" runScripts="before"></div>
  }
  @for (item of items; track item) {
    @if (html) {
      <div [innerHtml]="html | replaceTokensArray: {keys: item, previewVar: previewTemplateVar} | safe: 'html'"></div>
    }
  }
  @if (scripts) {
    <div [innerHTML]="scripts | safe: 'html'" runScripts="after"></div>
  }
}
